import {createContext} from "react";

const ClickContext = createContext();

export default ClickContext;
